export const ProductParameter = (json: IProductParameter): IProductParameterModel => {
	const fromJSON = (json: IProductParameter) => {
		const { value_label, return_values, ...rest } = json
		return {
			...rest,
			icon: 'orbit',
			returnValues: return_values,
			valueLabel: value_label,
		}
	}

	return { ...fromJSON(json) }
}

export const productParameterToJSON = (obj: Partial<IProductParameterModel>): Partial<IProductParameter> => {
	const { valueLabel, returnValues, ...rest } = obj
	return {
		...rest,
		return_values: returnValues,
		value_label: valueLabel,
	}
}
